import CalendarIcon from '@/assets/calendar.svg';
import UserIcon from '@/assets/user.svg';
import useIntl from '@/infrastructure/hooks/useIntl';
import {
  isEditDatesAtom,
  isEditTravelersAtom
} from '@/infrastructure/state/pickerVisibility';
import { Button } from '@mantine/core';
import clsx from 'clsx';
import { useAtom } from 'jotai';
import { FC } from 'react';

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useTrackEvent from '@/infrastructure/analytics/useTrackEvent';
import { chatRequestsAtom } from '@/infrastructure/state/chatRequests';
import { AccommodationsSearchRequestDto } from '@/features/AccommodationList/api/requestTypes';

import styles from './index.module.css';

const NoResultsSuggestions: FC = () => {
  const t = useIntl('chat');
  const [, setIsEditDates] = useAtom(isEditDatesAtom);
  const [, setIsEditTravelers] = useAtom(isEditTravelersAtom);
  const { trackEvent } = useTrackEvent();
  const [chatRequests] = useAtom(chatRequestsAtom);
  const location = useLocation();
  const state = location.state as { requestId?: string; isRefinement?: boolean } | null;
  const requestId = state?.requestId;

  const preferences = useMemo(() => {
    if (!requestId) return undefined;
    return chatRequests[requestId] as AccommodationsSearchRequestDto | undefined;
  }, [chatRequests, requestId]);

  const guestsCount = preferences ? (preferences.adults + (preferences.children || 0)) : undefined;
  const roomsCount = preferences ? preferences.rooms : undefined;

  return (
    <>
      <div className={styles.title}>{t('noAccommodationsTitle')}</div>
      <div className={styles.subtitle}>{t('noAccommodationsSubtitle')}</div>
      <div className={styles.buttons}>
        <Button
          variant="outline"
          color="primary"
          size="xs"
          radius="xl"
          bg="primary.0"
          className={clsx(styles.pillButton, styles.calendarButton)}
          onClick={() => {
            trackEvent('chat_suggestion_clicked', {
              category: 'Widget',
              label: 'different_dates',
              surface: 'chat',
              map_bounds_present: 'no',
              guests_count: guestsCount,
              rooms_count: roomsCount
            });
            trackEvent('change_dates_clicked', {
              category: 'Widget',
              surface: 'chat',
              map_bounds_present: 'no',
              guests_count: guestsCount,
              rooms_count: roomsCount
            });
            setIsEditDates(true);
            setIsEditTravelers(false);
          }}
          leftSection={<CalendarIcon />}
        >
          {t('differentDatesOption')}
        </Button>
        <Button
          variant="outline"
          color="primary"
          size="xs"
          radius="xl"
          bg="primary.0"
          className={clsx(styles.pillButton, styles.userButton)}
          onClick={() => {
            trackEvent('chat_suggestion_clicked', {
              category: 'Widget',
              label: 'edit_guests_rooms',
              surface: 'chat',
              map_bounds_present: 'no',
              guests_count: guestsCount,
              rooms_count: roomsCount
            });
            trackEvent('adjust_guests_rooms_clicked', {
              category: 'Widget',
              surface: 'chat',
              map_bounds_present: 'no',
              guests_count: guestsCount,
              rooms_count: roomsCount
            });
            setIsEditTravelers(true);
            setIsEditDates(false);
          }}
          leftSection={<UserIcon />}
        >
          {t('editGuestsRoomsOption')}
        </Button>
      </div>
    </>
  );
};

export default NoResultsSuggestions;
